import GetRedemptionDataResponse from "@/schemas/GetRedemptionDataResponse";
import { Flex, Modal, ModalProps, Typography } from "antd";

const { Text } = Typography;

export default function TwoDayModal(props: {
  redemption?: GetRedemptionDataResponse
  } & ModalProps
) {
  let hours = "72";
  const isku = props.redemption?.redemption?.InternalSku ?? "";

  /* match filters from backend */
  if (isku.startsWith("elitenet-") && isku.includes("-o2-")) {
    hours = "24";
  }

  return (
    <Modal
      title="Submission Confirmed!"
      okText="Confirm" {...props}
      cancelButtonProps={{ style: { display: "none" } }}
      closable={false}
    >
      <Flex gap={8} vertical style={{ whiteSpace: "pre-line" }}>
        { props.redemption?.mapping?.RedemptionDetails?.CustomRedemptionPopup ?
          <Text style={{ whiteSpace: "pre-line" }}>{props.redemption.mapping.RedemptionDetails.CustomRedemptionPopup}</Text>
          : <>
          <Text>Your QR code will be sent within { hours } hours of your arrival date!</Text>
          <Text>
            To change your arrival date, just click the same link in the email.
          </Text>
        </>}
      </Flex>
    </Modal>
  )
}